<div class="modal active">
  <div class="modal__container modal__container--md" style="top: 5%;">
      <div class="fields">
        <h2>Route Segments Import Options</h2>
        <div class="close" (click)="cancelImport()"><img src="/assets/img/close-white.svg" alt="" /></div>
        <div class="fields__container">
          <form name="ngImportCsvForm" #ngForm="ngForm" id="importCsvForm" class="active">
            <div class="fields__block">

              <div class="fields__block__section">
                <div class="title">
                  <h4>Layer Settings</h4>
                  <span> </span>
                </div>
                <div class="input-fields">
                  <div>
                    <label for="">Layer Name</label>
                    <input
                      maxlength="30"
                      [(ngModel)]="this.routeSegmentsService.modelXML.layerName"
                      type="text"
                      name="layerName"
                      id="layerName"
                      required
                    />
                  </div>
                </div>
                <div class="input-fields">
                  <div>
                    <label for="">Line Weight</label>
                    <input
                      maxlength="2"
                      [(ngModel)]="this.routeSegmentsService.modelXML.lineWeight"
                      type="number"
                      name="layerWeight"
                      id="layerWeight"
                      style="width: 62%"
                    />
                    <span style="width: 8%">pixels</span>
                  </div>
                </div>
                <div class="input-fields">
                  <div>
                    <label for="">Line Color</label>
                    <div>
                      <span style="width: auto; margin-right: 10px;display: inline-block;">{{ this.routeSegmentsService.modelXML.lineColor}}</span>
                      <!-- <input
                        [style.background]="this.routeSegmentsService.modelXML.lineColor"
                        [cpOKButton]="true"
                        [cpSaveClickOutside]="false"
                        [(colorPicker)]="this.routeSegmentsService.modelXML.lineColor"
                        [cpOutputFormat]="'rgba'"
                        [cpOKButtonClass]= "'blue'"
                        name="lineColor"
                        id="lineColor"
                      /> -->
                      <input style="padding: 0px;" type="color" id="lineColor" name="lineColor" value={{this.routeSegmentsService.modelXML.lineColor}} [(ngModel)]="this.routeSegmentsService.modelXML.lineColor">
                    </div>
                  </div>
                </div>
                <div class="input-fields">
                  <div>
                    <label for="">Line color for null val</label>
                    <div>
                      <span style="width: auto; margin-right: 10px;display: inline-block;">{{ this.routeSegmentsService.modelXML.lineColorNullVal}}</span>
                      <!-- <input
                        [style.background]="this.routeSegmentsService.modelXML.lineColorNullVal"
                        [cpOKButton]="true"
                        [cpSaveClickOutside]="false"
                        [(colorPicker)]="this.routeSegmentsService.modelXML.lineColorNullVal"
                        [cpOutputFormat]="'rgba'"
                        [cpOKButtonClass]= "'blue'"
                        name="lineColor"
                        id="lineColorNullVal"
                      /> -->
                      <input style="padding: 0px;" type="color" id="lineColorNullVal" name="lineColorNullVal" value={{this.routeSegmentsService.modelXML.lineColorNullVal}} [(ngModel)]="this.routeSegmentsService.modelXML.lineColorNullVal">
                    </div>
                  </div>
                </div>
              </div>
              <div class="fields__block__section">
                <div class="title">
                  <h4>XML Source File</h4>
                  <span> </span>
                </div>
                <div class="input-fields">
                  <div>
                    <label for="">File</label>
                    <input
                      style="padding-left: 0px;"
                      maxlength="300"
                      type="file"
                      name="filename"
                      id="filename"
                      (change)="saveFile($event)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="fields__btn">
              <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" (click)="startImport();" [disabled]="!ngForm.form.valid">
                Import
              </button>
              <button class="gray" (click)="cancelImport()">Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
